export enum EBILLING_QUERY_KEY {
  MY_SUBSCRIPTION = 'billing-my-subscription',
}
